var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71712 2.47683C2.65313 2.47683 2.59176 2.50225 2.54652 2.54749C2.50127 2.59274 2.47585 2.65411 2.47585 2.7181V10.845C2.47585 10.909 2.50127 10.9703 2.54652 11.0156C2.59176 11.0608 2.65313 11.0863 2.71712 11.0863C3.03271 11.0863 3.28854 11.3421 3.28854 11.6577C3.28854 11.9733 3.03271 12.2291 2.71712 12.2291C2.35003 12.2291 1.99798 12.0833 1.7384 11.8237C1.47883 11.5641 1.33301 11.2121 1.33301 10.845V2.7181C1.33301 2.35101 1.47883 1.99895 1.7384 1.73938C1.99798 1.47981 2.35003 1.33398 2.71712 1.33398H10.844C11.2111 1.33398 11.5632 1.47981 11.8227 1.73938C12.0823 1.99895 12.2281 2.35101 12.2281 2.7181C12.2281 3.03368 11.9723 3.28952 11.6567 3.28952C11.3411 3.28952 11.0853 3.03368 11.0853 2.7181C11.0853 2.65411 11.0599 2.59274 11.0146 2.54749C10.9694 2.50225 10.908 2.47683 10.844 2.47683H2.71712ZM5.15534 4.9149C5.02209 4.9149 4.91407 5.02292 4.91407 5.15616V13.2831C4.91407 13.4163 5.02209 13.5243 5.15534 13.5243H13.2822C13.4155 13.5243 13.5235 13.4163 13.5235 13.2831V5.15616C13.5235 5.02292 13.4155 4.9149 13.2822 4.9149H5.15534ZM3.77122 5.15616C3.77122 4.39174 4.39091 3.77205 5.15534 3.77205H13.2822C14.0467 3.77205 14.6663 4.39174 14.6663 5.15616V13.2831C14.6663 14.0475 14.0467 14.6672 13.2822 14.6672H5.15534C4.39091 14.6672 3.77122 14.0475 3.77122 13.2831V5.15616Z",
    fill: "#0079B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBlue);
export default __webpack_public_path__ + "static/media/copy-blue.10c2624cb32007ecb5c0e1f6a45c8664.svg";
export { ForwardRef as ReactComponent };